import React from "react";
import { Select, Option } from "@mui/joy";
import { MissionStatus } from "../../../api/assignments/Assignments.codes";

interface MissionStatusSelectorProps {
  value: MissionStatus;
  onChange: (status: MissionStatus) => void;
  disabled?: boolean;
}

const statusLabels: { [key in MissionStatus]: string } = {
  [MissionStatus.PENDING]: "En attente",
  [MissionStatus.IN_PROGRESS]: "En cours",
  [MissionStatus.DONE]: "Terminé",
};

const availableStatuses = [MissionStatus.IN_PROGRESS, MissionStatus.DONE];

const MissionStatusSelector: React.FC<MissionStatusSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <Select
    value={value}
    onChange={(e, newVal) => {
      if (newVal) onChange(newVal as MissionStatus);
    }}
    sx={{ width: "100%" }}
    size="sm"
    disabled={disabled}
  >
    {availableStatuses.map((status) => (
      <Option key={status} value={status}>
        {statusLabels[status]}
      </Option>
    ))}
  </Select>
);

export default MissionStatusSelector;
